"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInnerWidth = exports.getClientWidth = void 0;
const window_or_global_1 = __importDefault(require("window-or-global"));
const getClientWidth = () => {
    var _a, _b;
    if (!window_or_global_1.default.document) {
        return 0;
    }
    const clientWidth = ((_a = window_or_global_1.default.document.documentElement) === null || _a === void 0 ? void 0 : _a.clientWidth) || ((_b = window_or_global_1.default.document.getElementsByTagName('body')[0]) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0;
    return clientWidth;
};
exports.getClientWidth = getClientWidth;
const getInnerWidth = () => {
    return (window_or_global_1.default === null || window_or_global_1.default === void 0 ? void 0 : window_or_global_1.default.innerWidth) || 0;
};
exports.getInnerWidth = getInnerWidth;
//# sourceMappingURL=clientUtils.js.map